import React from 'react';
import SvgIcon from 'utils/SvgIcon';

const SafeIcon = ({ fillColor, hoverFill, style }) => (
  <SvgIcon
    {...{ fillColor, hoverFill, style }}
    width="18"
    height="18"
    viewBox="0 0 18 18"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.25 11.25C2.25 13.2453 4.5 15.2453 9 17.25C13.5 15.25 15.75 13.25 15.75 11.25C15.75 10.9639 15.7513 10.3525 15.7529 9.59603C15.7575 7.37783 15.7648 3.91293 15.75 3.75C15.75 3.17431 15.5291 3.04051 14.9176 2.67022C14.7324 2.5581 14.5115 2.42431 14.25 2.25C13.125 1.5 11.2464 0.75 9 0.75C6.42241 0.75 3.87135 2.1691 3.75 2.25C3.48854 2.42431 3.26759 2.5581 3.08245 2.67022C2.47095 3.04051 2.25 3.17431 2.25 3.75V11.25ZM14.2514 10.316C14.2504 10.7879 14.25 11.0773 14.25 11.25C14.25 12.3857 12.5791 13.9303 9.00069 15.6015C5.42183 13.9266 3.75 12.3813 3.75 11.25V4.0225L3.84585 3.96302C4.08838 3.81256 4.40448 3.61646 4.58205 3.49808C5.27148 3.03846 7.37857 2.25 9 2.25C10.6951 2.25 12.3107 2.75994 13.4179 3.49808C13.5955 3.61646 13.9116 3.81257 14.1542 3.96303L14.2572 4.02696C14.2588 4.47136 14.2595 5.90823 14.2568 7.58234L14.2544 8.85107L14.2514 10.316ZM11.25 6.75C12.0784 6.75 12.75 7.42157 12.75 8.25V11.25C12.75 12.0784 12.0784 12.75 11.25 12.75H6.75C5.92157 12.75 5.25 12.0784 5.25 11.25V8.25C5.25 7.42157 5.92157 6.75 6.75 6.75V5.25C6.75 4.00736 7.75736 3 9 3C10.2426 3 11.25 4.00736 11.25 5.25V6.75ZM9.75 5.25V6.75H8.25V5.25C8.25 4.83579 8.58579 4.5 9 4.5C9.41421 4.5 9.75 4.83579 9.75 5.25ZM6.75 11.25V8.25H11.25V11.25H6.75ZM8.25 9.75C8.25 10.1642 8.58579 10.5 9 10.5C9.41421 10.5 9.75 10.1642 9.75 9.75C9.75 9.33579 9.41421 9 9 9C8.58579 9 8.25 9.33579 8.25 9.75Z"
    />
  </SvgIcon>
);

export default SafeIcon;
